import { ref, get, child } from 'firebase/database';
import { database } from '../firebase';

/**
 * Test Firebase Realtime Database connectivity
 * @returns {Promise<Object>} Result of the connection test
 */
export const testDatabaseConnection = async () => {
  try {
    console.log('Testing Firebase Realtime Database connection...');
    const dbRef = ref(database);
    
    // Try to read the .info/connected node which is a special node that
    // indicates if the client is connected to the Firebase Realtime Database
    const snapshot = await get(child(dbRef, '.info/connected'));
    
    const isConnected = snapshot.exists() && snapshot.val() === true;
    
    return {
      success: true,
      connected: isConnected,
      message: isConnected 
        ? 'Successfully connected to Firebase Realtime Database' 
        : 'Connected to Firebase but database connection status is false'
    };
  } catch (error) {
    console.error('Firebase database connection test failed:', error);
    return {
      success: false,
      connected: false,
      message: `Error connecting to Firebase: ${error.message}`,
      error
    };
  }
};

/**
 * Verify that the announcements node is accessible
 * @returns {Promise<Object>} Result of the announcements node test
 */
export const testAnnouncementsAccess = async () => {
  try {
    console.log('Testing access to announcements node...');
    const announcementsRef = ref(database, 'announcements');
    
    // Try to read the announcements node
    await get(announcementsRef);
    
    return {
      success: true,
      message: 'Successfully accessed announcements node'
    };
  } catch (error) {
    console.error('Error accessing announcements node:', error);
    return {
      success: false,
      message: `Error accessing announcements node: ${error.message}`,
      error
    };
  }
}; 